<template>
  <div class="messages-wrapper">
    <div class="inside-wrapper">
      <div class="title">Message Board</div>
      <div class="message-name">{{ firstMessage }}</div>
      <div class="message-name">{{ secondMessage }}</div>
      <div class="message-name">{{ thirdMessage }}</div>
    </div>
  </div>
</template>
<script>
import userMixin from "@/mixins/userMixin"

export default {
  mixins: [userMixin],
  props: {
    userId: { type: Number }
  },
  computed: {
    messages() {
      let messages = this.$store.getters["systemMessages/getMessagesByUserId"](
        this.userId
      )

      return messages ? messages.slice(0, 3).reverse() : []
    },
    firstMessage() {
      return this.messages.length > 0 ? this.messages[0].body : ""
    },
    secondMessage() {
      return this.messages.length > 1 ? this.messages[1].body : ""
    },
    thirdMessage() {
      return this.messages.length > 2 ? this.messages[2].body : ""
    }
  },
  mounted() {
    this.$store.dispatch("systemMessages/loadMessages", this.userId)
  }
}
</script>

<style lang="scss" scoped>
@import "../../scss/variables";

div.messages-wrapper {
  background-color: $trophy-backgroud;
  border-radius: 25px;
  border-color: $light-grey;
  margin-top: 20px;
  position: relative;
}
div.title {
  color: $orange;
  display: flex;
  font-family: $main-font-family !important;
  font-style: italic;
  font-size: 1em !important;
  margin-left: 15px;
  margin-top: -25px;
  padding-left: 5px;
  position: absolute;
  text-transform: uppercase;
  width: 100%;
  justify-content: flex-start;
}
div.message-name {
  color: $dark-blue;
  background-color: $dark-beige;
  border-radius: 10px;
  line-height: 30px;
  margin: 6px 20px 12px 0;
  min-height: 36px;
  padding-left: 10px;
  vertical-align: center;
  width: 100%;
}
div.inside-wrapper {
  padding: 10px;
}
div.v-sheet {
  padding-left: 5px;
}
</style>
